import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import routes from "./routesConfig";
import Navbar from "./components/Navbar/Navbar.js";
import PrivateRoute from "./PrivateRoute.js";
import Login from "./pages/Login.js";
import Auth from "./services/AuthService.js";
import Loading from "./pages/Loading.js";
import Sidebar, { SidebarItem } from "./components/Sidebar"
import { ToastContainer } from "./components/Toast.js";

const AppRoutes = () => {
    const location = useLocation();
    const isLoginPage = location.pathname === "/login";
    const [loading, setLoading] = useState(true);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (Auth.isTokenExpired(token) && location.pathname !== "/login") {
            window.location.href = "/login";
        } else {
            setLoading(false);
        }
    }, [location]);

    if (loading) {
        return <Loading />;
    }

    return (
        <>
            {!isLoginPage ? (
                <div className="flex">
                    <Sidebar expanded={expanded} setExpanded={setExpanded}>
                        {routes.filter((route) => route.showList !== false).map((route) => (
                            <SidebarItem key={route.path} icon={route.icon} text={route.text} to={route.path} />
                        ))}
                    </Sidebar>

                    <div className={`w-full overflow-x-auto transition-all duration-300 ease-in-out ${expanded ? "ml-72" : "ml-16"}`}>
                        <Navbar />
                        <ToastContainer />
                        <Routes>
                            {routes.map((route) => (
                                <Route
                                    key={route.path}
                                    path={route.path}
                                    element={
                                        route.protected ? (
                                            <PrivateRoute element={route.element} />
                                        ) : (
                                            route.element
                                        )
                                    }
                                />
                            ))}
                        </Routes>
                    </div>
                </div>
            ) : (
                <Routes>
                    <Route path="/login" element={<Login />} />
                </Routes>
            )}
        </>
    );
};

export default AppRoutes;